import { obtainableFlowers } from './availability';
import { GOLDEN_SELL_MULTIPLIER } from './constants';
import { FLOWER_IDS, FLOWERS, type FlowerId } from './flowers';
import type { Rng } from './rng';
import type { GameState, MarketState } from './state';

export const FEATURED_MULTIPLIER = 1.6;
const MIN_MULTIPLIER = 0.75;
const MAX_MULTIPLIER = 1.35;

/** Rolls the day's market: every flower gets a price swing and one is featured. */
export function rollMarket(state: GameState, rng: Rng): MarketState {
  const multipliers = {} as Record<FlowerId, number>;
  for (const id of FLOWER_IDS) {
    multipliers[id] = Math.round(rng.range(MIN_MULTIPLIER, MAX_MULTIPLIER) * 100) / 100;
  }
  const featured = rng.pick(obtainableFlowers(state));
  multipliers[featured] = FEATURED_MULTIPLIER;
  return { day: state.day, multipliers, featured };
}

export function marketMultiplier(state: GameState, id: FlowerId): number {
  return state.market.multipliers[id] ?? 1;
}

/** Coins earned for selling one flower today. */
export function sellPrice(state: GameState, id: FlowerId, golden: boolean): number {
  const base = FLOWERS[id].sellPrice * marketMultiplier(state, id);
  return Math.max(1, Math.round(base * (golden ? GOLDEN_SELL_MULTIPLIER : 1)));
}
